import PhotoSwipe from 'photoswipe/dist/photoswipe.esm.js';

const galleries = {};

const renderContainer = (id = '') => {
  const pswp = document.createElement('div');

  pswp.id = id;
  pswp.classList.add('pswp');
  pswp.tabIndex = '-1';
  pswp.role = 'dialog';
  pswp.setAttribute('aria-hidden', true);

  pswp.innerHTML = `
  <div class="pswp__bg"></div>
    <div class="pswp__scroll-wrap">
      <div class="pswp__container">
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
      </div>

      <div class="pswp__ui pswp__ui--hidden">
        <div class="pswp__top-bar">
          <div class="pswp__counter"></div>

          <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
          <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
          <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

          <div class="pswp__preloader">
            <div class="pswp__preloader__icn">
              <div class="pswp__preloader__cut">
                <div class="pswp__preloader__donut"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
          <div class="pswp__share-tooltip"></div>
        </div>

        <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
        </button>

        <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
        </button>

        <div class="pswp__caption">
          <div class="pswp__caption__center"></div>
        </div>
      </div>
    </div>
  `;

  document.body.appendChild(pswp);

  return pswp;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
const photoswipeParseHash = () => {
  const hash = window.location.hash.substring(1);
  const params = {};

  if (hash.length < 5) {
    return params;
  }

  const vars = hash.split('&');

  // eslint-disable-next-line
  for (let i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      // eslint-disable-next-line
      continue;
    }

    const pair = vars[i].split('=');

    if (pair.length < 2) {
      // eslint-disable-next-line
      continue;
    }

    // eslint-disable-next-line prefer-destructuring
    params[pair[0]] = pair[1];
  }

  return params;
};

const openPhotoSwipe = (galleryUID, index = 0, thumbnail = null) => {
  const gallery = galleries[galleryUID];
  const options = {
    index,
    galleryUID,
    clickToCloseNonZoomable: false,
    history: false,
    getDoubleTapZoom: function (isMouseClick, item) {
      const galleryEl = item.container.closest('.pswp');

      if (!item.zoomLevel) {
        item.zoomLevel = item.initialZoomLevel;
      }

      var res;

      if (item.zoomLevel < 0.5) {
        galleryEl.classList.add('pswp--zoomable');
        galleryEl.classList.remove('pswp--unzoomable');
        res = 0.5;
      } else if (item.zoomLevel < 1) {
        res = 1;
      } else if (item.zoomLevel < 1.5) {
        res = 1.5;
        galleryEl.classList.remove('pswp--zoomable');
        galleryEl.classList.add('pswp--unzoomable');
      } else {
        res = item.initialZoomLevel;
        galleryEl.classList.add('pswp--zoomable');
        galleryEl.classList.remove('pswp--unzoomable');
      }

      item.zoomLevel = res;
      return res;
    },
    getThumbBoundsFn() {
      if (thumbnail) {
        const pageYScroll =
          window.pageYOffset || document.documentElement.scrollTop;
        const rect = thumbnail.getBoundingClientRect();

        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
      }

      return false;
    },
    bgOpacity: 0.7,
    showHideOpacity: true,
    // closeOnScroll: false,
  };

  const pswp = new PhotoSwipe({
    gallery: gallery.el,
    pswpModule: PhotoSwipe,
    dataSource: gallery.items,
    options,
  });

  pswp.init();
};

/**
 * Setup PhotoSwipe Galleries.
 *
 * @export
 */
export default function setupPhotoswipes() {
  const pswpTriggers = Array.from(document.querySelectorAll('[data-pswp]'));

  if (pswpTriggers.length) {
    pswpTriggers.forEach((trigger) => {
      const galleryId = trigger.dataset.pswp || 'default';
      const src = trigger.dataset.pswpSrc;
      const size = trigger.dataset.pswpSize
        ? trigger.dataset.pswpSize.split('x')
        : false;
      const title = trigger.dataset.pswpTitle || trigger.alt || '';
      const clickable = trigger.dataset.pswpClickable !== 'false';
      let index = trigger.dataset.pswpIndex || 0;
      const galleryExists = typeof galleries[galleryId] === 'object';

      if (src && size) {
        if (galleryExists) {
          index = galleries[galleryId].items.findIndex((i) => i.src === src);
        }

        if (size) {
          const item = {
            src,
            title,
            w: parseInt(size[0], 10),
            h: parseInt(size[1], 10),
          };

          if (!galleryExists) {
            // Create gallery object if it doesn't already exist.
            galleries[galleryId] = {
              el: renderContainer(galleryId),
              items: [item],
            };
          } else if (index === -1) {
            // Add item to existing gallery if hasn't previously been added.
            galleries[galleryId].items.push(item);
            index = galleries[galleryId].items.length - 1;
          }
        }
      }

      if (clickable) {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();

          let thumbnail = false;

          if (src) {
            index = galleries[galleryId].items.findIndex((i) => i.src === src);

            if (size) {
              thumbnail = e.target;
            }
          }

          openPhotoSwipe(galleryId, index, thumbnail);
        });
      }
    });

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    const hashData = photoswipeParseHash();

    if (hashData.pid && hashData.gid) {
      openPhotoSwipe(hashData.gid, hashData.pid);
    }

    const pswpAltTriggers = Array.from(
      document.querySelectorAll('[data-pswp-target]')
    );

    pswpAltTriggers.forEach((trigger) => {
      const target = document.getElementById(trigger.dataset.pswpTarget);

      if (target) {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();

          target.click();
        });
      }
    });
  }

  /**
   * Setup galleries from inline script.
   */
  if (typeof window.galleries === 'object') {
    Object.keys(window.galleries).forEach((key) => {
      if (galleries[key]) {
        window.galleries[key].items.forEach((item) => {
          const index = galleries[key].items.findIndex(
            (i) => i.src === item.src
          );

          if (index < 0) {
            galleries[key].items.push(item);
          }
        });
      } else {
        galleries[key] = window.galleries[key];
        galleries[key].el = renderContainer(key);
      }
    });
  }
}
